exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sell-in-status__not_applied{color:#FB4B53}.sell-in-status__applied{color:#24A148}\n", ""]);

// exports
